import {createSlice} from "@reduxjs/toolkit";

const initialVehicleDocsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  vehicledocForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const vehicledocsSlice = createSlice({
  name: "vehicledocs",
  initialState: initialVehicleDocsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getVehicleDocById
    vehicledocFetched: (state, action) => {
      state.actionsLoading = false;
      state.vehicledocForEdit = action.payload.vehicledocForEdit;
      state.error = null;
    },
    // findVehicleDocs
    vehicledocsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createVehicleDoc
    vehicledocCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.vehicledoc);
    },
    // updateVehicleDoc
    vehicledocUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.vehicledoc.id) {
          return action.payload.vehicledoc;
        }
        return entity;
      });
    },
    // deleteVehicleDoc
    vehicledocDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteVehicleDocs
    vehicledocsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // vehicledocsUpdateState
    vehicledocsStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
